module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("Communication preferences")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('dismissable-alert', {
    attrs: {
      "title": "Communication preference updated!",
      "closeAction": _vm.hideCommunicationUpdatedAlert,
      "isShowing": _vm.communicationUpdated
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Choose your communication preferences")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg top-margin bottom-margin",
    attrs: {
      "type": "button",
      "disabled": _vm.isReadOnly || _vm.allEmail
    },
    on: {
      "click": _vm.setAllToEmail
    }
  }, [_vm._v("\n        Set All Delivery Methods to Email\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive bottom-margin"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Transaction Notices & Options Forms")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "transactions",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.transactionsEmail
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setExclusivePreference('TRANSACTIONS', 'EMAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  })])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "transactions",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.transactionsPostal
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setExclusivePreference('TRANSACTIONS', 'SNAIL-MAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  })])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Impact Report (annual each fall)")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "impactReport",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.impactReportEmail
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setExclusivePreference('IMPACT_REPORT', 'EMAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  })])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "impactReport",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.impactReportPostal
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setExclusivePreference('IMPACT_REPORT', 'SNAIL-MAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  })])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("\n                1099 Tax Form (annual each January, can select both email & postal)\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.form1099Email
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggle1099('EMAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  })])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.form1099Postal
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggle1099('SNAIL-MAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  })])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_vm._v("\n        All of the above, as well as Monthly Statements and other Reports are always\n        available in your Documents section online.\n      ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticClass: "text-center delivery-col"
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    staticClass: "text-center delivery-col"
  }, [_vm._v("Postal Mail")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfd44448","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorCommunicationPreferences.vue
// module id = 2199
// module chunks = 1